<h2 mat-dialog-title class="copo-color-orange" translate>settings.remove-service</h2>
<mat-dialog-content>
	<div class="copo-simple-dialog-content">
		<div>
			<span translate>settings.remove-service-confirmation</span><b><span class="featured"> {{data}}</span></b>?
		</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions class="button-group">
	<button type="button" mat-button [mat-dialog-close]="false" class="save-cancel-button-block copo-button-font">
		<span translate>filter.cancel</span>
	</button>
	<button type="submit" mat-button [mat-dialog-close]="true" class="copo-blue-dark-grey-button">
		<span translate>dashboard.validate</span>
	</button>
</mat-dialog-actions>